import { gql } from '@apollo/client';

export const POST_REGISTER_FORM = gql`
	mutation CreateContact($input: CreateContactInput!) {
		createContact(input: $input) {
            id
        }
	}
`;